/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by mj codegen manifest
 * App: mj_explorer
 * Dependency tree: 1 packages contain @RegisterClass
 *
 * This file imports every @RegisterClass decorated class by name and places
 * them in an exported array, creating a static code path that prevents
 * tree-shaking from removing them.
 */

/* eslint-disable @typescript-eslint/no-unused-vars */

// mj_generatedentities (96 classes)
import {
    membersuiteBatchEntity,
    membersuiteBusinessUnitEntity,
    membersuiteCOGSEntryEntity,
    membersuiteCancellationFeeProductEntity,
    membersuiteChangeMemoLineItemEntity,
    membersuiteChapterDuesProductEntity,
    membersuiteCreditEntity,
    membersuiteCreditLineItemEntity,
    membersuiteCreditMemoEntity,
    membersuiteDebitMemoEntity,
    membersuiteDiscountProductEntity,
    membersuiteDueToDueFromEntryEntity,
    membersuiteFiscalYearEntity,
    membersuiteFundraisingProductEntity,
    membersuiteGLAccountEntity,
    membersuiteIndividualEntity,
    membersuiteInvoiceEntity,
    membersuiteInvoiceLineItemEntity,
    membersuiteLateFeeProductEntity,
    membersuiteLegacyProductEntity,
    membersuiteMembershipDuesProductEntity,
    membersuiteMerchandiseEntity,
    membersuiteMiscellaneousProductEntity,
    membersuiteOrderEntity,
    membersuiteOrderLineItemEntity,
    membersuiteOrganizationEntity,
    membersuitePaymentEntity,
    membersuitePaymentLineItemEntity,
    membersuiteProductEntity,
    membersuiteRefundEntity,
    membersuiteRefundLineItemEntity,
    membersuiteRegistrationFeeEntity,
    membersuiteRevenueRecognitionScheduleEntity,
    membersuiteRevenueRecognitionScheduleEntryEntity,
    membersuiteSectionDuesProductEntity,
    membersuiteShippingProductEntity,
    membersuiteSubscriptionFeeEntity,
    membersuiteTaxProductEntity,
    membersuiteWriteOffEntity,
    membersuitesubledger_entry_batchesEntity,
    membersuitesubledger_entry_itemsEntity,
    soundpostAccountingAllocationRuleEntity,
    soundpostAccountingEntryEntity,
    soundpostAccountingEntryLineDimensionEntity,
    soundpostAccountingEntryLineEntity,
    soundpostAccountingPeriodEntity,
    soundpostAccountingScheduleEntity,
    soundpostAgreementEntity,
    soundpostAgreementLineEntity,
    soundpostAgreementStatusEntity,
    soundpostAgreementTypeEntity,
    soundpostCompanySequenceEntity,
    soundpostConfigKeyEntity,
    soundpostControlAccountTypeEntity,
    soundpostCurrencyEntity,
    soundpostCustomerEntity,
    soundpostDimensionEntity,
    soundpostDimensionTypeEntity,
    soundpostExchangeRateEntity,
    soundpostGLAccountEntity,
    soundpostGLAccountMappingEntity,
    soundpostGLAccountTypeEntity,
    soundpostOrchestrationRunEntity,
    soundpostOrchestrationRunStepEntity,
    soundpostOrderEntity,
    soundpostOrderLineEntity,
    soundpostPaymentEntity,
    soundpostPaymentLineEntity,
    soundpostPostingGroupEntity,
    soundpostPostingGroupLineDimensionEntity,
    soundpostPostingGroupLineEntity,
    soundpostProcessingBatchEntity,
    soundpostProcessingErrorEntity,
    soundpostProductEntity,
    soundpostProductGLAccountDimensionEntity,
    soundpostProductGLAccountEntity,
    soundpostReconBalanceSnapshotEntity,
    soundpostReconFlowCategoryEntity,
    soundpostReconFlowSnapshotEntity,
    soundpostReconRunEntity,
    soundpostReconRunIntegrationEntity,
    soundpostReportOutputARAgingEntity,
    soundpostReportOutputAccountActivitySummaryEntity,
    soundpostReportOutputAccountingEntryLineEntity,
    soundpostReportOutputAgreementBalanceEntity,
    soundpostReportOutputAgreementGLActivitySummaryEntity,
    soundpostReportOutputDeferredRevenueByScheduleEntity,
    soundpostReportOutputDeferredRevenueDetailEntity,
    soundpostReportOutputDeferredRevenueSummaryEntity,
    soundpostReportOutputOrderPaymentLineEntity,
    soundpostReportOutputProductGLActivitySummaryEntity,
    soundpostReportRunEntity,
    soundpostReportTypeEntity,
    soundpostRevenueRecognitionRuleEntity,
    soundpostSyncLogEntity,
    soundpostTrialBalanceEntity,
} from 'mj_generatedentities';

/**
 * Runtime references to every @RegisterClass decorated class.
 * This array creates a static code path the bundler cannot tree-shake.
 *
 * Split into fixed-size chunks so no single array literal grows a union large
 * enough to trip TS2590; the exported array is their concatenation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CLASS_REGISTRATIONS_0: any[] = [
    membersuiteBatchEntity,
    membersuiteBusinessUnitEntity,
    membersuiteCOGSEntryEntity,
    membersuiteCancellationFeeProductEntity,
    membersuiteChangeMemoLineItemEntity,
    membersuiteChapterDuesProductEntity,
    membersuiteCreditEntity,
    membersuiteCreditLineItemEntity,
    membersuiteCreditMemoEntity,
    membersuiteDebitMemoEntity,
    membersuiteDiscountProductEntity,
    membersuiteDueToDueFromEntryEntity,
    membersuiteFiscalYearEntity,
    membersuiteFundraisingProductEntity,
    membersuiteGLAccountEntity,
    membersuiteIndividualEntity,
    membersuiteInvoiceEntity,
    membersuiteInvoiceLineItemEntity,
    membersuiteLateFeeProductEntity,
    membersuiteLegacyProductEntity,
    membersuiteMembershipDuesProductEntity,
    membersuiteMerchandiseEntity,
    membersuiteMiscellaneousProductEntity,
    membersuiteOrderEntity,
    membersuiteOrderLineItemEntity,
    membersuiteOrganizationEntity,
    membersuitePaymentEntity,
    membersuitePaymentLineItemEntity,
    membersuiteProductEntity,
    membersuiteRefundEntity,
    membersuiteRefundLineItemEntity,
    membersuiteRegistrationFeeEntity,
    membersuiteRevenueRecognitionScheduleEntity,
    membersuiteRevenueRecognitionScheduleEntryEntity,
    membersuiteSectionDuesProductEntity,
    membersuiteShippingProductEntity,
    membersuiteSubscriptionFeeEntity,
    membersuiteTaxProductEntity,
    membersuiteWriteOffEntity,
    membersuitesubledger_entry_batchesEntity,
    membersuitesubledger_entry_itemsEntity,
    soundpostAccountingAllocationRuleEntity,
    soundpostAccountingEntryEntity,
    soundpostAccountingEntryLineDimensionEntity,
    soundpostAccountingEntryLineEntity,
    soundpostAccountingPeriodEntity,
    soundpostAccountingScheduleEntity,
    soundpostAgreementEntity,
    soundpostAgreementLineEntity,
    soundpostAgreementStatusEntity,
    soundpostAgreementTypeEntity,
    soundpostCompanySequenceEntity,
    soundpostConfigKeyEntity,
    soundpostControlAccountTypeEntity,
    soundpostCurrencyEntity,
    soundpostCustomerEntity,
    soundpostDimensionEntity,
    soundpostDimensionTypeEntity,
    soundpostExchangeRateEntity,
    soundpostGLAccountEntity,
    soundpostGLAccountMappingEntity,
    soundpostGLAccountTypeEntity,
    soundpostOrchestrationRunEntity,
    soundpostOrchestrationRunStepEntity,
    soundpostOrderEntity,
    soundpostOrderLineEntity,
    soundpostPaymentEntity,
    soundpostPaymentLineEntity,
    soundpostPostingGroupEntity,
    soundpostPostingGroupLineDimensionEntity,
    soundpostPostingGroupLineEntity,
    soundpostProcessingBatchEntity,
    soundpostProcessingErrorEntity,
    soundpostProductEntity,
    soundpostProductGLAccountDimensionEntity,
    soundpostProductGLAccountEntity,
    soundpostReconBalanceSnapshotEntity,
    soundpostReconFlowCategoryEntity,
    soundpostReconFlowSnapshotEntity,
    soundpostReconRunEntity,
    soundpostReconRunIntegrationEntity,
    soundpostReportOutputARAgingEntity,
    soundpostReportOutputAccountActivitySummaryEntity,
    soundpostReportOutputAccountingEntryLineEntity,
    soundpostReportOutputAgreementBalanceEntity,
    soundpostReportOutputAgreementGLActivitySummaryEntity,
    soundpostReportOutputDeferredRevenueByScheduleEntity,
    soundpostReportOutputDeferredRevenueDetailEntity,
    soundpostReportOutputDeferredRevenueSummaryEntity,
    soundpostReportOutputOrderPaymentLineEntity,
    soundpostReportOutputProductGLActivitySummaryEntity,
    soundpostReportRunEntity,
    soundpostReportTypeEntity,
    soundpostRevenueRecognitionRuleEntity,
    soundpostSyncLogEntity,
    soundpostTrialBalanceEntity,
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CLASS_REGISTRATIONS: any[] = [
    ...CLASS_REGISTRATIONS_0,
];

/** Marker constant indicating the manifest has been loaded. */
export const CLASS_REGISTRATIONS_MANIFEST_LOADED = true;

/** Total @RegisterClass decorated classes discovered in dependency tree */
export const CLASS_REGISTRATIONS_COUNT = 96;

/** Packages imported by this manifest */
export const CLASS_REGISTRATIONS_PACKAGES = [
    'mj_generatedentities',
] as const;
